import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetNumManagedKeychainParams {
  id?: string;
}

export interface IGetNumManagedKeychainResult {
  totalManagedKeychainCount: number;
  orphanedManagedKeychainCount: number;
}

export class GetNumManagedKeychainsRequest extends Request<IGetNumManagedKeychainParams, IGetNumManagedKeychainResult> {
  constructor(params: IGetNumManagedKeychainParams) {
    super('getNumManagedKeychainsForSite', params);
  }
}
